module.exports = __webpack_public_path__ + "static/trollback-86bbd50f6528a598b4e06567580a60e9.png";